import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { AvailabilityDatePickerComponent } from './availability-date-picker/availability-date-picker.component';

@Component({
  selector: 'blaze-dates-range-picker',
  templateUrl: './dates-range-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, AvailabilityDatePickerComponent],
  host: { class: 'flex items-center gap-8' },
})
export class DatesRangePickerComponent {
  private readonly elementRef = inject(ElementRef);

  value = input.required<{ since: string | null; until: string | null }>();
  errors = input.required<Record<string, string>>();
  valueChanged = output<{ since: string | null; until: string | null }>();

  errorSince = computed(() => this.errors()['since']);
  errorUntil = computed(() => (this.untilTouched() ? this.errors()['until'] : undefined));

  untilTouched = signal(false);

  onValueChanged(event: string | null, field: 'since' | 'until'): void {
    this.valueChanged.emit({ ...this.value(), [field]: event });
    if (field === 'since') {
      setTimeout(() => {
        if (!this.errorSince()) {
          tryFocusUntilInput(this.elementRef.nativeElement);
        }
      });
    }
  }
}

function tryFocusUntilInput(el: HTMLElement): void {
  const target = el.querySelector(
    'blaze-availability-date-picker[placeholder=Until] .mat-datepicker-input',
  ) as HTMLInputElement;
  if (!target) {
    return;
  }
  target.focus();
  target.click();
}
